const largeSizes = {
  container: "105rem",
}

const sizes = {
  ...largeSizes,
}

export default sizes
